import { MailIcon } from 'lucide-react'

import { useIsTrialing } from '@/modules/account'
import { useProject } from '@/modules/projects/hooks'
import { isProjectProcessing } from '@/modules/projects/status'
import { cn } from '@/utils'

export const TrialProcessingNote = ({ className }: { className?: string }) => {
  const isTrialing = useIsTrialing()
  const isProcessing = isProjectProcessing(useProject())

  if (!isTrialing || !isProcessing) return null

  return (
    <p
      role="status"
      className={cn('flex items-center gap-2 text-sm', className)}
    >
      <MailIcon aria-hidden className="size-4 shrink-0 text-brand-deep" />
      This takes a few minutes. We will email you when it is ready.
    </p>
  )
}
